import {endpoints} from './endpoints'
import request from '../request'

export function addElementToProjectLine (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addElementToProjectLine,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateProjectLineInfo (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateProjectLineInfo,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyProjectLines (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyProjectLines,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectLineDocuments (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectLineDocuments,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}